
// const debug = "PlanningManger"
const debug = false

export default class PlanningManger {

    static projectStartEnd(projectId:ID, startDate:Moment|null, endDate:Moment|null, options:any = {}) {
        let newStartDate    = startDate ? moment(startDate) : null
        let newEndDate      = endDate ? moment(endDate) : null

        if (!newEndDate) newStartDate = endDate
        if (!newStartDate || (newEndDate && newEndDate.isBefore(newStartDate)))
            newEndDate = newStartDate

        if (options.duration && newEndDate && !endDate) {
            newEndDate.add(options.duration - 1, 'days')
        }

        if (!options.noApiCall) gd.api.Projects.startEnd(projectId,newStartDate,newEndDate);

        debug && console.log(debug, 'projectStartEnd', options, {
            startDate: newStartDate,
            endDate: newEndDate
        })

        return {
            startDate: newStartDate,
            endDate: newEndDate
        }
    }

    static projectDeadline(projectId:ID, date:Moment|null) {
        const request = gd.api.Project.setDeadline(projectId,date);
        return date;
    }

    static taskDeadline(taskId:ID, date:Moment|null) {
        gd.api.Task.setDeadline(taskId,date);
        return date;
    }

    static getNewTaskPlanning(listParent:any) {
        const today = moment(moment().format("YYYY-MM-DD"));
        let start;
        if ([gd.const.project.type.BACKLOG].includes(listParent.item.systemType)) {
            start = listParent.getDisplayStartEndDate().displayStartDate;
        } else {
            start = listParent.item.startDate;
        }
        if (start && start.isBefore(today, 'day')) start = null;

        return {
            startDate: start ? start.format("YYYY-MM-DD") : null,
            endDate: start ? start.format("YYYY-MM-DD") : null
        };
    }

    static getNewProjectPlanning(listParent:any) {
        const { displayStartDate } = listParent.item;
        const start = displayStartDate ? displayStartDate.format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
        return {
            startDate: start,
            endDate: start
        }
    }

    static getTaskPlanningByEstimate(estimate:any, baseDate:any) {
        const date = baseDate ?  moment(baseDate) : moment();
        let days = estimate ? Math.ceil(estimate/ (60 * 8)) - 1 : 0;
        if (days < 0) days = 0;

        return {
            startDate: date,
            endDate: moment(date).add(days, 'days')
        }
    }

    static eventStartEnd(eventId:ID, startDate:any, endDate:any, options:any = {}) {
        if (!options.noApiCall) gd.api.Events.setStartEnd(eventId,startDate,endDate);
        return {startDate,endDate}
    }
}
